import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
} from '@chakra-ui/react';
import React, { useCallback, useEffect } from 'react';
import Layout from '../Layout';

import { IoKey } from 'react-icons/io5';
import { FcGlobe } from 'react-icons/fc';

import { SiBookstack } from 'react-icons/si';

import { Menu, Item, useContextMenu } from 'react-contexify';

import 'react-contexify/dist/ReactContexify.css';
import {
  explainFurtherPrompt,
  provideExamplesPrompt,
  scrollbarStyles,
  simplifyFurtherPrompt,
  summarizeFurtherPrompt,
} from '../Constants';
import { useSocket } from '../../Context/SocketContext';

import { MultiturnChat } from '../Helpers/MultiturnChat';
import ReactMarkdown from 'react-markdown';
import { useAuth } from '../../Context/AuthContext';

const AccordionBody = ({ payload }) => {
  const socket = useSocket();
  const { setTopLevelError } = useAuth();

  useEffect(() => {
    if (Object.keys(payload).length === 0) {
      setTopLevelError(
        'No Smart Notes found for this topic. Please try again later.'
      );
    }
  }, [payload]);

  const { show } = useContextMenu({
    id: 'smartNotesContextMenu',
  });

  function handleItemClick({ id, event, props, triggerEvent, data }) {
    if (!socket) return;

    let prompt;

    switch (id) {
      case 'menuitem_explain':
        prompt = explainFurtherPrompt;
        break;
      case 'menuitem_simplify':
        prompt = simplifyFurtherPrompt;
        break;
      case 'menuitem_summarize':
        prompt = summarizeFurtherPrompt;
        break;
      case 'menuitem_examples':
        prompt = provideExamplesPrompt;
        break;
      default:
        prompt = explainFurtherPrompt;
    }

    const extendedPrompt =
      prompt +
      '<highlighted_text>' +
      props?.selectedText +
      '</highlighted_text>';

    socket.emit('smartnotesmenu', {
      question: extendedPrompt,
      state: {
        type: 'smartnotes',
      },
    });
  }

  const handleContextMenu = event => {
    // Prevent the default context menu

    const selectedText = window.getSelection().toString().trim();
    if (selectedText) {
      // Show the context menu at the mouse position
      show({
        id: 'smartNotesContextMenu',
        event: event,
        props: { selectedText: selectedText },
      });
    }
    event.preventDefault();
  };

  return (
    <Accordion defaultIndex={[2]} allowMultiple>
      <AccordionItem>
        <h2>
          <AccordionButton>
            <Flex
              flex="1"
              alignItems="center"
              textAlign="left"
              fontSize={{ base: '1rem', md: '1.5rem' }}
              color="#1B2559"
              fontWeight="600"
            >
              Key Points{' '}
              <IoKey
                style={{
                  marginLeft: '4px',
                  color: 'goldenrod',
                  fontSize: '1.5rem',
                }}
              />
            </Flex>
            <AccordionIcon />
          </AccordionButton>
        </h2>

        <AccordionPanel
          pb={4}
          color="#1B2559"
          fontSize="0.9rem"
          fontWeight="500"
          onClick={handleContextMenu}
        >
          <ReactMarkdown>{payload['Key Points']}</ReactMarkdown>
          {/* {payload['Key Points']} */}
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem>
        <h2>
          <AccordionButton>
            <Flex
              flex="1"
              alignItems="center"
              textAlign="left"
              fontSize={{ base: '1rem', md: '1.5rem' }}
              color="#1B2559"
              fontWeight="600"
            >
              Real World Examples{' '}
              <FcGlobe style={{ marginLeft: '4px', fontSize: '1.5rem' }} />
            </Flex>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel
          pb={4}
          color="#1B2559"
          fontSize="0.9rem"
          fontWeight="500"
          onClick={handleContextMenu}
        >
          <ReactMarkdown>{payload['Real-World Examples']}</ReactMarkdown>
          {/* {payload['Real-World Examples']} */}
        </AccordionPanel>
      </AccordionItem>

      <AccordionItem>
        <h2>
          <AccordionButton>
            <Flex
              flex="1"
              alignItems="center"
              textAlign="left"
              fontSize={{ base: '1rem', md: '1.5rem' }}
              color="#1B2559"
              fontWeight="600"
            >
              Core Notes{' '}
              <SiBookstack
                style={{
                  marginLeft: '4px',
                  color: '#488b48',
                  fontSize: '1.5rem',
                }}
              />
            </Flex>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel
          pb={4}
          color="#1B2559"
          fontSize="0.9rem"
          fontWeight="500"
          // onClick={handleContextMenu}
          onClick={handleContextMenu}
          // onClick={handleContextMenu}
        >
          <ReactMarkdown>{payload['Core Notes']}</ReactMarkdown>
          {/* {payload['Core Notes']} */}
        </AccordionPanel>
      </AccordionItem>
      <Menu id="smartNotesContextMenu">
        <Item id="menuitem_explain" onClick={handleItemClick}>
          Explain Further
        </Item>
        <Item id="menuitem_simplify" onClick={handleItemClick}>
          Simplify
        </Item>
        <Item id="menuitem_summarize" onClick={handleItemClick}>
          Summarize Key Points
        </Item>
        <Item id="menuitem_examples" onClick={handleItemClick}>
          Provide Examples
        </Item>
      </Menu>
    </Accordion>
  );
};

const Body = ({ currentTab, payload }) => {
  const { setTopLevelError } = useAuth();

  useEffect(() => {
    if (payload?.creditLimitReach) {
      setTopLevelError(
        'You have reached your credit limit. Please subscribe to continue using this feature'
      );
    }
  }, [payload]);

  const NotesTabBodyRenderer = useCallback(
    () => <AccordionBody payload={payload?.smartNotes ?? {}} />,
    [payload]
  );

  const DoubtTabBodyRenderer = useCallback(
    () => <MultiturnChat chatType="smartnotes" />,
    []
  );

  return (
    <Flex h="100%" direction={{ base: 'column', md: 'row' }}>
      <Box
        // maxW={{ base: '100%', md: '50%' }}
        width="100%"
        overflowY={{ base: 'unset', md: 'auto' }}
        display={{
          base: currentTab === 'notes-tab' ? 'block' : 'none',
          md: 'block',
        }}
        sx={scrollbarStyles}
      >
        <Layout
          height="fit-content"
          body={NotesTabBodyRenderer}
          hasGenericFooter={false}
        />
      </Box>
      <Box
        // maxW={{ base: '100%', md: '50%' }}
        width="100%"
        height="100%"
        overflowY={{ base: 'unset', md: 'auto' }}
        display={{
          base: currentTab === 'doubts-tab' ? 'block' : 'none',
          md: 'block',
        }}
        // mt={{ base: '1.2rem', md: '0' }}
        sx={scrollbarStyles}
      >
        <Layout
          height="100%"
          body={DoubtTabBodyRenderer}
          showBackgroundImage={true}
          hasGenericFooter={false}
          // gridFooterRegionHeight="50px"
        />
      </Box>
    </Flex>
  );
};

export default Body;
